// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
// Components, Layouts, Pages
import { BasePagination, BaseStatus, Loading } from '~/components/common';
// Others
import { ITruck } from '~/utils/interface/truck';
import { StatusEnum } from '~/utils/enum/common';
import { getListTruck } from '~/thunks/truck/truckThunk';
import { useAppDispatch } from '~/utils/redux/hooks';
import { IQueryParamBase } from '~/utils/interface/common';
import { IPaginationResponse } from '~/utils/interface/base';
import { DEFAULT_CURRENT_PAGE, DEFAULT_LIMIT_PAGE_DASHBOARD, EMPTY_VALUE } from '~/utils/constants/common';
// Styles, images, icons
import styles from './VehicleMaintenance.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const VehicleMaintenance = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard']);
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paramObject, setParamObject] = useState<IQueryParamBase>({
    page: DEFAULT_CURRENT_PAGE,
    limit: DEFAULT_LIMIT_PAGE_DASHBOARD,
    status: StatusEnum.INACTIVE,
  });
  const [pagination, setPagination] = useState<IPaginationResponse>();

  const [truckList, setTruckList] = useState<ITruck[]>([]);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    handleGetListTruck(paramObject);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramObject]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetListTruck = (params: IQueryParamBase) => {
    setIsLoading(true);

    dispatch(getListTruck(params))
      .unwrap()
      .then((res) => {
        const { responses, pagination } = res.data;

        if (!responses) return;

        setTruckList(responses);
        setPagination(pagination);
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handlePageChange = (_event: ChangeEvent<unknown>, page: number) => {
    setParamObject({ ...paramObject, page });
  };
  //#endregion Handle Function

  return (
    <Box id='vehicleMaintenanceComponent' className={cx('container')}>
      <Stack direction={'row'} spacing={'13px'} justifyContent={'space-between'} justifyItems={'center'}>
        <Typography className={cx('title')}>{t('dashboard_title_vehicle_maintenance')}</Typography>

        <Stack className={cx('viewStatusTitle')}>
          <Typography className={cx('statusTitle')}>
            {t('overbooking_title_inactive', {
              value: truckList.length,
            })}
          </Typography>
        </Stack>
      </Stack>

      <Stack className={cx('content')}>
        {truckList && truckList.length > 0 ? (
          truckList.map((item, index) => (
            <Stack key={item?.id} className={cx('itemTask', index < truckList.length - 1 && 'border')}>
              <Stack direction={'column'} gap={1}>
                <Typography className={cx('titleItem')}>{`${item?.name} #${item?.id}`}</Typography>

                <Typography className={cx('titleSub')}>{item?.truckType || EMPTY_VALUE}</Typography>
              </Stack>

              <BaseStatus label={item.status} type='big' />
            </Stack>
          ))
        ) : (
          <Typography align='center' className={cx('noData')}>
            {t('common_no_data_available', { ns: 'common/base' })}
          </Typography>
        )}
      </Stack>

      <BasePagination count={pagination?.totalPages} page={pagination?.page} onChange={handlePageChange} />

      {isLoading && <Loading />}
    </Box>
  );
};

export default VehicleMaintenance;
